import React from "react";
import { Text, Span, Heading } from "@catchoftheday/cg-components";

type LinkedContentProps = {
  email?: string;
};

export const LinkedContent: React.FC<LinkedContentProps> = ({ email }) => {
  return (
    <>
      <Heading.h3
        fontFamily="onePass"
        fontWeight="bold"
        color="onePass.textPrimary"
        m="0px"
      >
        Account already linked
      </Heading.h3>
      <Text
        fontSize="base"
        fontWeight="medium"
        my="24px"
        fontFamily="onePass"
        color="onePass.textPrimary"
      >
        You are currently logged in at Catch with{" "}
        <Span fontWeight="bold">{email}</Span>. This Catch account is already
        linked to a different OnePass account.
      </Text>
      <Text
        fontSize="base"
        fontWeight="medium"
        mb="32px"
        fontFamily="onePass"
        color="onePass.textPrimary"
      >
        Would you like to replace the current linking?
      </Text>
    </>
  );
};
